import { Userflow } from 'userflow.js';

export type UserFlowSafeMethods = Omit<
  Userflow,
  | 'init'
  | 'identify'
  | 'group'
>;

export type UserFlowInitData<User, Channel> = {
  apiKey: string;
  user: User;
  channel: Channel,
}
